import { createFileRoute } from "@tanstack/react-router"
import { SettingsOverview } from "@/features/settings/components"
import { settingsOverviewQuery } from "@/features/settings/core/hooks/useSettingsOverview"

export const Route = createFileRoute("/(authenticated)/settings/")({
  loader: ({ context }) => {
    void context.queryClient.ensureQueryData(settingsOverviewQuery())
  },
  component: SettingsOverview,
})
